// Règle d'espacement des révisions (J1, J3, J7…) selon le score de l'item, ou une liste commune.
window.SPACING_RULES = {
    3: [1, 3, 7, 14, 21, 30, 45, 60],
    2: [2, 5, 10, 20, 30, 60],
    1: [3, 7, 15, 30, 60],
    0: [7, 14, 30, 60]
};
// Liste de J écrite à la main (« 1, 3, 7, 14, 30, 60 ») → entiers positifs, croissants, sans doublon.
window.parseJListe = function(txt) {
    var vus = {}, out = [];
    String(txt || '').split(/[^0-9]+/).forEach(function(x) { var n = parseInt(x, 10); if (n > 0 && n <= 365 && !vus[n]) { vus[n] = 1; out.push(n); } });
    return out.sort(function(a, b) { return a - b; });
};
// Règle d'espacement d'un item : selon son score (par défaut), ou la même liste de J pour tous les items
// (réglage « Rythme des révisions » de l'ordonnanceur, gardé dans les préréglages).
window.regleEspacement = function(score) {
    if (window.state && window.state.spacingMode === 'commun') { var l = window.parseJListe(window.state.spacingCommun); if (l.length) return l; }
    return window.SPACING_RULES[score] || window.SPACING_RULES[0];
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const SPACING_RULES = window.SPACING_RULES;
export const parseJListe = window.parseJListe;
export const regleEspacement = window.regleEspacement;
